// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Box = require("./Atom_Box.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Logo_Ds = require("./Atom_Logo_Ds.bs.js");
var Atom_Logo_Css = require("./Atom_Logo_Css.bs.js");
var Atom_Logo_Path = require("./Atom_Logo_Path.bs.js");

function Atom_Logo(Props) {
  var logo = Props.logo;
  var dsLogo = Atom_Logo_Ds.makeLogo(logo);
  var match = Atom_Logo_Ds.view(dsLogo);
  var match$1 = Atom_Logo_Css.toCss(dsLogo);
  var wrapperRule = match$1.wrapper;
  var __x = Belt_Array.map(match$1.svg, (function (rule) {
          var __x = [rule];
          return CssJs.style(__x);
        }));
  var svgClassName = CssJs.merge(__x);
  var exec = function (_logo) {
    while(true) {
      var logo = _logo;
      if (typeof logo !== "object") {
        return Atom_Logo_Path.getPath(logo);
      }
      if (logo.NAME !== "WithWrapper") {
        return Atom_Logo_Path.getPath(logo);
      }
      _logo = logo.VAL[0];
      continue ;
    };
  };
  var svg = React.createElement("svg", {
        "aria-hidden": true,
        className: svgClassName,
        focusable: "false",
        viewBox: match.viewBox,
        xmlns: "http://www.w3.org/2000/svg"
      }, exec(logo));
  if (wrapperRule !== undefined) {
    return React.createElement(Atom_Box.make, {
                children: svg,
                rules: Caml_option.valFromOption(wrapperRule)
              });
  } else {
    return svg;
  }
}

var make = Atom_Logo;

exports.make = make;
/* CssJs Not a pure module */
